export const content = {
  pt: {
    translations: {
      forms: {
        required: "Obrigatório",
        fileSize: "O ficheiro tem de ser menos que ",
      },
      topBar: {
        memory: "Memória",
        hope: "Esperança",
        audacity: "Audácia",
      },
      menuBar: {
        about: "_sobre",
        stories: "_histórias",
        contacts: "_contatos",
      },

      adminSideBar: {
        submitBook: "Gerir Histórias",
        manageCarroussel: "Gerir Carrousel",
        back: "Voltar",
      },
      modules: {
        home: {
          carrousel: {
            button: "Visitar História",
          },
          mainTextBtn: "LEIA MAIS",
          stories: "_Histórias",
          comingSoon: "Coming Soon",
          comingSoonS:
            "A coletar punches para vos apresentar nos próximos dias. Fiquem atentos!",
        },

        about: {
          title: "_Sobre",
          mainText:
            "Este projeto nasce com a irrequietude que é necessária para falar com e sobre pessoas, sejam conhecidas ou desconhecidas, e coletar os seus momentos de impacto.<br /><br /> As histórias que serão contadas são de pessoas reais, que se “despem” para expor os seus momentos de perda, dor, alegria e angústia. Estas pessoas, embora reais, poderão surgir nas suas histórias com nomes fictícios, de modo a protegerem o impacto da sua própria história noutros.<br /><br /> Uma boa história é intemporal e pode mudar atitudes.<br /><br /> Quero criar impactos!<br /><br /> Ass. Teresa Sá.",
        },
        contacts: {
          title: "_Contactos",
          mainText:
            "Quer fazer parte deste projeto?<br />Vamos ser, juntos, o que somos, pessoas com momentos de impacto.<br /><br />Qual o teu punch moment?<br />Quero saber mais.<br />Envia-me a tua história para: <b>punchstories@outlook.pt</b>",
        },
        books: {
          book: {
            bookTitle: "Título",
            text: "Texto:",
            price: "Preço:",
            design: "Ilustração:",
            translation: "Tradução:",
            pages: "Número de páginas:",
            language: "Language:",
            weight: "Peso:",
            size: "Dimensões:",
            collectionBrowser: "Mais da Coleção",
            bookBrowser: "FOLHEAR\n O LIVRO",
            new: "Novo",
            title: "DESCRIÇÃO",
            writer: "AUTOR",
            designer: "ILUSTRADOR",
            translator: "TRADUTOR",
          },
          viewBook: {
            page: "PÁGINAS",
          },
        },
        admin: {
          manageBooks: {
            createButton: "Adicionar nova História",
            submitBook: {
              breadCrumbs: "Gerir Livros - Submeter Livro",
              submitTitle: "Submeter Livro",
              title: "Titulo",
              pages: "Número de paginas",
              coverPage: "Imagem Rosto",
              content: "Conteudo",
              author: "Escritor",
              authorResume: "Resumo do Escritor",
              designer: "Ilustrador",
              designerResume: "Resumo do Designer",
              translator: "Tradutor",
              translatorResume: "Resumo do Tradutor",
              language: "Idioma",
              weight: "Peso",
              size: "Tamanho",
              resume: "Resumo",
              price: "Preço",
              template: "Template",
              punchLines: "Punch Lines",
              ps: "Post Scriptum",
            },
            tableList: {
              title: "Título História",
              createdDate: "Data Criação",
              template: { title: "Template", tooltip: "Change Template" },
              newBook: {
                title: "Nova História?",
                accept: "Prosseguir",
                deny: "Cancelar",
                confirmationDescription:
                  "Tem a certeza que quer mudar o estado deste livro?",
                confirmationTitle: "Mudar o estado do livro",
                tooltip: "Novo Livro (estado)",
              },
            },
          },
          manageCarroussell: {
            submitTitle: "Gerir Carrousel",
            imagesKeep: "Imagens a manter",
            imagesDelete: "Imagens para apagar",
          },
        },
      },
      notifications: {
        success: {
          newBook: "Livro adicionado com sucesso",
          updateCarroussell: "O carrousel foi actualizado",
          newCarrousselImage: "Foi adicionada uma nova imagem ao carrousel",
          newBookStatusChanged: "Estado do livro foi alterado",
        },
        fail: {
          fetchStories: "Somethng went wrong, while getting the stories",
          newBook: "Livro não foi adicionado, algum erro ocorreu",
          updateCarroussell: "O carrousel não foi actualizado",
          newCarrousselImage: "Não foi adicionada uma nova imagem ao carrousel",
          newBookStatusChanged: "Estado do livro não foi alterado",
        },
      },
    },
  },
};
